import React, { useState, useEffect } from "react";
import OTPVerification from "../../components/steps/OTPVerification";
import {
  formatOTPRequest,
  formatOTPVerification
} from "../utilities/utilities";
import IntlTelInput from "react-intl-tel-input";
import EpInlineLoader from "../common/EpInlineLoader";

function ContactInfoVerification(props) {
  const { values, setData, errors, dirty, navigation, t } = props;
  const [state, setState] = useState({
    otpReference: "",
    otpValue: "",
    otpRequestError: "",
    otpValidationError: "",
    isOtpValidated: false,
    showOtpSection: false,
    isSendOtpLoading: false,
    isVerifyOtpLoading: false,
    isOtpEntered: false,
    otpVerification: "",
    disableNumberInput: false,
    disableOtpInput: false,
  });


  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  const handleOTPRequest = () => {
    const requestData = formatOTPRequest(values);
    setState((prevState) => {
      return {
        ...prevState,
        otpRequestError: "",
        isSendOtpLoading: true,
        otpValue: "",
        disableNumberInput: true,
        otpVerification: "",
      };
    });
    fetch( process.env.REACT_APP_PRODUCTS_API_BASE_URL +"/services/embassy/api/OtpCode/send", {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify(requestData),
    })
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        if (data && data.transactionId !== "") {
          setState((prevState) => {
            return {
              ...prevState,
              otpReference: data.transactionId,
              showOtpSection: true,
              isSendOtpLoading: false,
            };
          });
        } else {
          setState((prevState) => {
            return {
              ...prevState,
              otpRequestError: "Something went wrong. Please try again.",
              showOtpSection: false,
              isSendOtpLoading: false,
            };
          });
        }
      });
  };

  const handleOTPVerification = (otpValue) => {
    const requestData = formatOTPVerification(state, otpValue);
  
    fetch(  process.env.REACT_APP_PRODUCTS_API_BASE_URL +"/services/embassy/api/OtpCode/Verify", {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify(requestData),
    })
      .then((response) => {
        if (!response.ok) {
          setState((prevState) => {
            return {
              ...prevState,
              otpRequestError: "Something went wrong. Please try again.",
              isSendOtpLoading: false,
              otpVerification: "FAILED",
            };
          });
        } else {
         response.json().then(data=>{
          setData({ name: "accessToken", value: data.accessToken });
          setState((prevState) => {
            return {
              ...prevState,
              isOtpValidated: true,
              isSendOtpLoading: false,
              otpVerification: "SUCCESS"
            };
          });
          setData({ name: "isMobileVerified", value: true });
         })
        }
      })
      .catch(error => console.log('error', error));
  };

  const handleFlagSelection = (number, country) => {
    setData({ name: "mobileNumber", value: number });
    setData({ name: "mobileDialCode", value: country.dialCode });
    setData({ name: "mobileISOCode", value: country.iso2 });
    setData({ name: "mobileCountryName", value: country.name });
  };
  const handlePhoneNumberOnChange = (isValid, number, country) => {
    number = number.replace(/^0+/, "");
    setData({ name: "mobileNumber", value: number });
    setData({ name: "mobileDialCode", value: country.dialCode });
    setData({ name: "mobileISOCode", value: country.iso2 });
    setData({ name: "mobileCountryName", value: country.name });
    setData({ name: "isMobileValid", value: isValid });
  };

  const properties = {
    values,
    state,
    setState,
    handleOTPRequest,
    handleOTPVerification,
    t
  };
  return (
    <div className="contact-section mt-5">
      <div className="row">
        <div className="col-sm-6 mb-3">
          <div className="row">
            <div className="col-sm-12 ">
              <img
                src="./images/phone-icon.svg"
                alt="Phone Icon"
                className="input-icon"
              />
            </div>
            <div className="col-sm-12 py-3">
              <h4>
                {t("PLEASE_PROVIDE_YOUR")} 
              </h4>
            </div>
            <div className="col-sm-12 contact-verification-section">
              <div
                className={
                  !values.isMobileValid && dirty.mobileNumber
                    ? "form-group invalid"
                    : "form-group"
                }
              >
                <label htmlFor="contactnumber">{t("CONTACT_NUMBER")}</label>
                <>
                  <IntlTelInput
                    preferredCountries={["ae", "fr"]}
                    containerClassName="intl-tel-input"
                    inputClassName="form-control form-control-lg"
                    onPhoneNumberChange={handlePhoneNumberOnChange}
                    onSelectFlag={handleFlagSelection}
                    onChange={handlePhoneNumberOnChange}
                    value={values.mobileNumber}
                    name="mobileNumber"
                    fieldId="mobileNumber"
                    fieldName="mobileNumber"
                    separateDialCode={true}
                    disabled={state.disableNumberInput}
                  />
                </>
                {!values.isMobileValid && dirty.mobileNumber && (
                  <div className="error-message">{t(errors["mobileNumber"])}</div>
                )}
              </div>
            </div>
            <div className="col-5 mt-5  dir-left">
              <button
                className="btn btn-lg btn-default btn-back "
                onClick={() => {
                  if (values.serviceTypeCode === "GOOD") {
                    setData({ name: "embassyCode", value: "" });
                    setData({ name: "selectedEmbassyCode", value: "" });
                    setData({ name: "serviceTypeCode", value: "" });
                    setData({ name: "selectedServiceTypeCode", value: "" });
                    navigation.go("select-embassy");
                  } else {
                    navigation.go("address-details");
                  }
                }}
              
              >
                <img src="./images/arrow-left.svg" alt="" />
                {t("BACK")}
              </button>
            </div>

            <div className="col-7 mt-5  dir-right">
              {!state.showOtpSection && (
                <button
                  className="btn btn-primary btn-lg emx-button"
                  onClick={handleOTPRequest}
                  disabled={!values.isMobileValid}
                >
                  {!state.isSendOtpLoading && <>{t("SEND_OTP")}</>}
                  {state.isSendOtpLoading && (
                    <>
                      <EpInlineLoader />
                    </>
                  )}
                </button>
              )}
             
            </div>
           
          </div>
        </div>
        <div className="col-sm-6 mb-3">
          <div className="otp-display-section">
            {state.showOtpSection && <OTPVerification {...properties} />}
          </div>
          <div className="row">
            <div className="col-sm-12 dir-right mt-4">
              {state.showOtpSection && state.isOtpValidated && state.otpVerification === "SUCCESS" && (
                <button
                  className="btn btn-primary btn-lg"
                  onClick={() => {
                    navigation.go(
                      values.serviceTypeCode === "GOOD"
                        ? "good-enter-details"
                        : "review-details"
                    );
                  }}
                >
                  {t("PROCEED")}
                </button>
              )}
            </div>
          </div>
        </div>
      </div>

    </div>
  );
}

export default ContactInfoVerification;
